var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.member.avatar)?_c('img',{attrs:{"src":'/dist/images/' + _vm.member.avatar,"alt":""}}):_c('span',{staticClass:"icon-user mr-2"}),_vm._v(" "+_vm._s(_vm.member.getFullName())+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }